"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var icon_type_1 = require("./icon-type");
var caret_down_1 = require("./sprites/caret-down");
var caret_left_1 = require("./sprites/caret-left");
var caret_right_1 = require("./sprites/caret-right");
var caret_up_1 = require("./sprites/caret-up");
var checkmark_circle_filled_1 = require("./sprites/checkmark-circle-filled");
var checkmark_circle_outlined_1 = require("./sprites/checkmark-circle-outlined");
var chevron_down_1 = require("./sprites/chevron-down");
var chevron_left_1 = require("./sprites/chevron-left");
var chevron_right_1 = require("./sprites/chevron-right");
var chevron_up_1 = require("./sprites/chevron-up");
var clear_1 = require("./sprites/clear");
var delete_1 = require("./sprites/delete");
var done_1 = require("./sprites/done");
var drag_1 = require("./sprites/drag");
var error_outlined_1 = require("./sprites/error-outlined");
var gap_1 = require("./sprites/gap");
var info_1 = require("./sprites/info");
var info_filled_1 = require("./sprites/info-filled");
var message_failed_1 = require("./sprites/message-failed");
var message_failed_outlined_1 = require("./sprites/message-failed-outlined");
var more_vertical_1 = require("./sprites/more-vertical");
var notifications_on_1 = require("./sprites/notifications-on");
var notifications_on_outlined_1 = require("./sprites/notifications-on-outlined");
var notifications_outlined_1 = require("./sprites/notifications-outlined");
var plus_1 = require("./sprites/plus");
var warning_1 = require("./sprites/warning");
var warning_outlined_1 = require("./sprites/warning-outlined");
function Icon(props) {
    var iconName = props.iconName, _a = props.size, size = _a === void 0 ? icon_type_1.IconSize.SMALL : _a, _b = props.fill, fill = _b === void 0 ? 'black' : _b, restProps = __rest(props, ["iconName", "size", "fill"]);
    var commonProps = __assign({ size: size, fill: fill }, restProps);
    if (iconName === icon_type_1.IconName.CARET_DOWN) {
        return (0, jsx_runtime_1.jsx)(caret_down_1.CaretDown, __assign({}, commonProps));
    }
    if (iconName === icon_type_1.IconName.CARET_LEFT) {
        return (0, jsx_runtime_1.jsx)(caret_left_1.CaretLeft, __assign({}, commonProps));
    }
    if (iconName === icon_type_1.IconName.CARET_RIGHT) {
        return (0, jsx_runtime_1.jsx)(caret_right_1.CaretRight, __assign({}, commonProps));
    }
    if (iconName === icon_type_1.IconName.CARET_UP) {
        return (0, jsx_runtime_1.jsx)(caret_up_1.CaretUp, __assign({}, commonProps));
    }
    if (iconName === icon_type_1.IconName.CHECK_MARK_CIRCLE_FILLED) {
        return (0, jsx_runtime_1.jsx)(checkmark_circle_filled_1.CheckmarkCircleFilled, __assign({}, commonProps));
    }
    if (iconName === icon_type_1.IconName.CHECK_MARK_CIRCLE_OUTLINED) {
        return (0, jsx_runtime_1.jsx)(checkmark_circle_outlined_1.CheckmarkCircleOutlined, __assign({}, commonProps));
    }
    if (iconName === icon_type_1.IconName.CHEVRON_DOWN) {
        return (0, jsx_runtime_1.jsx)(chevron_down_1.ChevronDown, __assign({}, commonProps));
    }
    if (iconName === icon_type_1.IconName.CHEVRON_LEFT) {
        return (0, jsx_runtime_1.jsx)(chevron_left_1.ChevronLeft, __assign({}, commonProps));
    }
    if (iconName === icon_type_1.IconName.CHEVRON_RIGHT) {
        return (0, jsx_runtime_1.jsx)(chevron_right_1.ChevronRight, __assign({}, commonProps));
    }
    if (iconName === icon_type_1.IconName.CHEVRON_UP) {
        return (0, jsx_runtime_1.jsx)(chevron_up_1.ChevronUp, __assign({}, commonProps));
    }
    if (iconName === icon_type_1.IconName.CLEAR) {
        return (0, jsx_runtime_1.jsx)(clear_1.Clear, __assign({}, commonProps));
    }
    if (iconName === icon_type_1.IconName.DELETE) {
        return (0, jsx_runtime_1.jsx)(delete_1.Delete, __assign({}, commonProps));
    }
    if (iconName === icon_type_1.IconName.DONE) {
        return (0, jsx_runtime_1.jsx)(done_1.Done, __assign({}, commonProps));
    }
    if (iconName === icon_type_1.IconName.DRAG) {
        return (0, jsx_runtime_1.jsx)(drag_1.Drag, __assign({}, commonProps));
    }
    if (iconName === icon_type_1.IconName.ERROR_OUTLINED) {
        return (0, jsx_runtime_1.jsx)(error_outlined_1.ErrorOutlined, __assign({}, commonProps));
    }
    if (iconName === icon_type_1.IconName.GAP) {
        return (0, jsx_runtime_1.jsx)(gap_1.Gap, __assign({}, commonProps));
    }
    if (iconName === icon_type_1.IconName.INFO) {
        return (0, jsx_runtime_1.jsx)(info_1.Info, __assign({}, commonProps));
    }
    if (iconName === icon_type_1.IconName.INFO_FILLED) {
        return (0, jsx_runtime_1.jsx)(info_filled_1.InfoFilled, __assign({}, commonProps));
    }
    if (iconName === icon_type_1.IconName.MESSAGE_FAILED) {
        return (0, jsx_runtime_1.jsx)(message_failed_1.MessageFailed, __assign({}, commonProps));
    }
    if (iconName === icon_type_1.IconName.MESSAGE_FAILED_OUTLINED) {
        return (0, jsx_runtime_1.jsx)(message_failed_outlined_1.MessageFailedOutlined, __assign({}, commonProps));
    }
    if (iconName === icon_type_1.IconName.MORE_VERTICAL) {
        return (0, jsx_runtime_1.jsx)(more_vertical_1.MoreVertical, __assign({}, commonProps));
    }
    if (iconName === icon_type_1.IconName.NOTIFICATIONS_OUTLINED) {
        return (0, jsx_runtime_1.jsx)(notifications_outlined_1.NotificationOutlined, __assign({}, commonProps));
    }
    if (iconName === icon_type_1.IconName.NOTIFICATION_ON) {
        return (0, jsx_runtime_1.jsx)(notifications_on_1.NotificationOn, __assign({}, commonProps));
    }
    if (iconName === icon_type_1.IconName.NOTIFICATION_ON_OUTLINED) {
        return (0, jsx_runtime_1.jsx)(notifications_on_outlined_1.NotificationsOnOutlined, __assign({}, commonProps));
    }
    if (iconName === icon_type_1.IconName.PLUS) {
        return (0, jsx_runtime_1.jsx)(plus_1.Plus, __assign({}, commonProps));
    }
    if (iconName === icon_type_1.IconName.WARNING) {
        return (0, jsx_runtime_1.jsx)(warning_1.Warning, __assign({}, commonProps));
    }
    if (iconName === icon_type_1.IconName.WARNING_OUTLINED) {
        return (0, jsx_runtime_1.jsx)(warning_outlined_1.WarningOutlined, __assign({}, commonProps));
    }
    return (0, jsx_runtime_1.jsx)("svg", {});
}
exports.Icon = Icon;
